import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalValidityFilter = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.filterValidity');
  const onClose = () => {
    closeSingleModal('filterValidity');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de validades'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Validity.Validity.Filter />
    </Modal>
  );
};

export default ModalValidityFilter;
